var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-scroll-y-transition',{attrs:{"leave-absolute":""}},[_c('TopicCard',_vm._g(_vm._b({},'TopicCard',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }